<template>
    <b-dropdown
        size="sm"
        variant="link"
        toggle-class="text-decoration-none m-0 p-0"
        no-caret
        dropleft
        :disabled="disabled"
        :id="id"
    >
        <template slot="button-content">
            <i class="fas fa-ellipsis-v" />
        </template>
        <b-dropdown-item-button id="btn-okr-edit-objective" @click="onEditCallback" :disabled="hasNotEditPermission">
            <strong class="text-muted">{{ $t('form.button.edit') }}</strong>
        </b-dropdown-item-button>
        <div v-if="onDuplicateCallback && canDuplicate">
            <b-dropdown-divider />
            <b-dropdown-item-button
                id="btn-okr-move-objective"
                @click="onDuplicateCallback"
                :disabled="hasNotDuplicatePermission"
            >
                <strong class="text-muted">{{ $t('form.button.duplicate') }}</strong>
            </b-dropdown-item-button>
        </div>
        <div v-if="onMoveCallback && canMove">
            <b-dropdown-divider />
            <b-dropdown-item-button
                id="btn-okr-move-objective"
                @click="onMoveCallback"
                :disabled="hasNotMovePermission"
            >
                <strong class="text-muted">{{ $t('form.button.move') }}</strong>
            </b-dropdown-item-button>
        </div>
        <div v-if="onRequestCollaborationCallback">
            <b-dropdown-divider />
            <b-dropdown-item-button
                id="btn-okr-request-collaboration-objective"
                @click="onRequestCollaborationCallback"
                :disabled="hasNotRequestCollaborationPermission"
            >
                <strong class="text-muted">{{ $t('form.button.requestCollaboration') }}</strong>
            </b-dropdown-item-button>
        </div>
        <b-dropdown-divider />
        <b-dropdown-item-button
            id="btn-okr-delete-objective"
            @click="onDeleteCallback"
            :disabled="hasNotDeletePermission"
        >
            <strong class="text-muted">{{ $t('form.button.delete') }}</strong>
        </b-dropdown-item-button>
        <b-tooltip :target="id" v-if="disabled">
            {{ disabledTooltipLabel }}
        </b-tooltip>
    </b-dropdown>
</template>

<script>
export default {
    name: 'Dropdown',
    props: {
        id: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        onEditCallback: {
            type: Function,
            required: true,
        },
        onDeleteCallback: {
            type: Function,
            required: true,
        },
        onDuplicateCallback: {
            type: Function,
            required: false,
        },
        onMoveCallback: {
            type: Function,
            required: false,
        },
        canDuplicate: {
            type: Boolean,
            required: false,
        },
        canMove: {
            type: Boolean,
            required: false,
        },
        onRequestCollaborationCallback: {
            type: Function,
            required: false,
        },
        hasNotEditPermission: {
            type: Boolean,
            default: false,
            required: false,
        },
        hasNotDuplicatePermission: {
            type: Boolean,
            default: false,
            required: false,
        },
        hasNotMovePermission: {
            type: Boolean,
            default: false,
            required: false,
        },
        hasNotRequestCollaborationPermission: {
            type: Boolean,
            default: false,
            required: false,
        },
        hasNotDeletePermission: {
            type: Boolean,
            default: false,
            required: false,
        },
        disabledTooltipLabel: {
            type: String,
            required: false,
        },
    },
}
</script>
